import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import api from "@/lib/api";

// Section « Nos conseillers » — nom, rôle et courte présentation (sans photo).
// Le contenu est géré depuis l'espace admin (collection advisors).
export const AdvisorsSection = () => {
  const [advisors, setAdvisors] = useState([]);

  useEffect(() => {
    api.get("/advisors").then((r) => setAdvisors(r.data || [])).catch(() => setAdvisors([]));
  }, []);

  if (!advisors.length) return null;

  return (
    <section data-testid="advisors-section" className="relative bg-navy overflow-hidden">
      <div className="pointer-events-none absolute -top-32 -left-24 w-[30rem] h-[30rem] rounded-full bg-gold/10 blur-[120px]" />
      <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <div className="text-center">
          <span className="inline-block text-xs sm:text-sm uppercase tracking-[0.25em] text-gold font-semibold">
            Une équipe à votre écoute
          </span>
          <h2 className="mt-4 font-heading font-medium text-white text-3xl sm:text-4xl lg:text-5xl leading-tight">
            Rencontrez votre <span className="text-gold">conseiller</span>
          </h2>
          <div className="gold-line mx-auto mt-6" />
          <p className="mt-5 max-w-2xl mx-auto text-white/70 text-base sm:text-lg leading-relaxed">
            Des experts dédiés vous accompagnent à chaque étape de votre projet vers le Canada ou l'Australie.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {advisors.map((a, i) => (
            <motion.div
              key={a.id}
              data-testid={`advisor-card-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-sm p-7 transition-all duration-300 hover:border-gold/50 hover:-translate-y-1"
            >
              <span className="absolute right-6 top-6 text-gold/25 group-hover:text-gold/50 transition-colors">
                <Quote size={34} />
              </span>
              <h3 className="font-heading text-2xl text-white">{a.name}</h3>
              <p className="mt-1 text-sm uppercase tracking-widest text-gold font-semibold">{a.role}</p>
              <span className="block gold-line mt-4 !w-10" />
              <p className="mt-4 text-white/75 text-sm sm:text-base leading-relaxed">{a.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
